"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _theme = require("../theme");

var _colors = require("../theme/colors");

var _typography = require("../theme/typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Text = props => {
  const [css, theme] = (0, _theme.useStyletron)();
  const {
    tag = 'span',
    typography = _typography.TypographyKeys.BodyText3,
    color = _colors.TextColorKeys.grey90,
    bold = false,
    className = '',
    children
  } = props;
  const Element = tag;
  return /*#__PURE__*/_react.default.createElement(Element, {
    className: `
        ${css({ ...theme.typography[typography.toString()],
      ...(bold ? theme.typography.bold : {}),
      color: color === 'inherit' ? 'inherit' : theme.colors[color.toString()] || color
    })}
        ${className}
      `
  }, children);
};

var _default = Text;
exports.default = _default;